import styled from 'styled-components';

export const CurrentConditionsSummary = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: calc(100% - 109px);
`;
